
import 'moment/locale/ru'
import moment from 'moment-timezone'
import Calendar from '../Calendar/Calendar.vue'
import EventCard from '../EventCard/EventCard.vue'
import EventCardSkeleton from '../EventCard/EventCardSkeleton.vue'
import { getTimezone } from '../../api'
import { firstLetterUpperCase } from '~/utils/helpers'

export default {
  name: 'CalendarDashboard',
  components: { EventCardSkeleton, EventCard, Calendar },
  data() {
    return {
      isShowMobileEventModal: false,
      selectedDay: null,
      nearEvent: {},
      timeZoneFetched: false,
      monthHolidays: {},
      eventForMobileModal: {},
      isMobileDevice: this.$device.isMobile
    }
  },

  computed: {
    holidaysDatesText() {
      let { from, to } = this.monthHolidays
      if (from && to) {
        const isSameMonths = moment(from).isSame(moment(to), 'month')
        const fromFormat = isSameMonths ? 'D' : 'D MMMM'
        from = moment(from).format(fromFormat)
        to = moment(to).format('D MMMM')

        return `с ${from} по ${to}`
      }

      return 'Каникул нет'
    },

    nearEventLoading() {
      return this.nearEvent?.isLoading
    },

    nearEventFormatDate() {
      return this.nearEvent?.date?.format('DD MMMM')
    },

    selectedDayDate() {
      const date = this.selectedDay?.totalDate
      if (date) {
        const Today = date.isSame(moment(), 'day') ? 'Сегодня, ' : ''
        const Tomorrow = date.isSame(moment().add(1, 'days'), 'day')
          ? 'Завтра, '
          : ''

        return (
          (Today || Tomorrow) + firstLetterUpperCase(date.format('dd, DD MMMM'))
        )
      }

      return ''
    },

    selectedDayEvents() {
      return this.selectedDay?.events || []
    },

    isShowHolidays() {
      return this.selectedDay?.holidays
    }
  },

  async mounted() {
    moment.locale('ru')
    const { timeZone } = (await this.getTimezone()) || {}
    if (timeZone && Object.keys(timeZone)?.length) {
      moment.tz.setDefault(timeZone?.iana)
    }
    this.timeZoneFetched = true
  },

  methods: {
    getTimezone,

    clickEvent(e) {
      if (this.isMobileDevice) {
        this.eventForMobileModal = e
        this.isShowMobileEventModal = true
      }
    },

    addDays(num) {
      this.$refs.calendar.addDays(num)
    },

    subtractDays(num) {
      this.$refs.calendar.subtractDays(num)
    },

    selectToday() {
      this.$refs.calendar.selectToday()
    },

    openModal() {
      this.$refs.calendar.openModal()
    },

    selectDay(selectedDayData) {
      const { day, nearEvent, monthHolidays } = selectedDayData
      this.monthHolidays = monthHolidays || {}

      if (nearEvent) {
        this.nearEvent = nearEvent
      }
      this.selectedDay = day
    }
  }
}
